import { render, staticRenderFns } from "./ReportImages.vue?vue&type=template&id=52830a90&"
import script from "./ReportImages.vue?vue&type=script&lang=js&"
export * from "./ReportImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QSelect,QIcon,QBtn,QTooltip,QExpansionItem,QItemSection} from 'quasar'
component.options.components = Object.assign({QItem,QSelect,QIcon,QBtn,QTooltip,QExpansionItem,QItemSection}, component.options.components || {})
